import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';

const APPROVALS_DISABLED_ERROR_MESSAGE = 'Approvals are disabled';

type GraphQLErrorLike = {
	readonly message?: string | null;
};

type ApolloErrorLike = GraphQLErrorLike & {
	readonly graphQLErrors?: ReadonlyArray<GraphQLErrorLike> | null;
};

const isApprovalsDisabledGraphQLError = (error: GraphQLErrorLike): boolean =>
	Boolean(error.message?.includes(APPROVALS_DISABLED_ERROR_MESSAGE));

export const isApprovalsDisabledError = (
	error: ApolloErrorLike | GraphQLErrorLike | null | undefined,
): boolean => {
	if (!error) return false;

	const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
	if (graphQLErrors?.length) {
		return graphQLErrors.every(isApprovalsDisabledGraphQLError);
	}

	return isApprovalsDisabledGraphQLError(error);
};

export const markApprovalsDisabledErrorAsHandled = (
	error: ApolloErrorLike | GraphQLErrorLike | null | undefined,
): void => {
	if (isApprovalsDisabledError(error)) {
		markErrorAsHandled(error);
	}
};
